/* Reana Foods – product slider (migrated from homepage Custom Liquid).
   Custom element: re-initialises automatically when the Theme Editor
   re-renders a section. */
if (!customElements.get('reana-slider')) {
  class ReanaSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-reana-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-reana-dot]'));
      this.prev = this.querySelector('[data-reana-prev]');
      this.next = this.querySelector('[data-reana-next]');
      this.current = 0;
      this.timer = null;
      this.paused = false;
      this.autoplay = this.dataset.autoplay !== 'false';
      this.speed = (parseInt(this.dataset.speed, 10) || 4) * 1000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.slides.length) return;

      this.onPrev = () => { this.show(this.current - 1); this.start(); };
      this.onNext = () => { this.show(this.current + 1); this.start(); };
      this.onKey = (e) => {
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); this.onPrev(); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); this.onNext(); }
      };
      this.onVisibility = () => (document.hidden ? this.stop() : this.start());
      this.onFocusIn = () => { this.paused = true; this.stop(); };
      this.onFocusOut = (e) => {
        if (!this.contains(e.relatedTarget)) { this.paused = false; this.start(); }
      };
      this.onBlockSelect = (e) => {
        const index = this.slides.indexOf(e.target.closest && e.target.closest('[data-reana-slide]'));
        if (index > -1) { this.designMode = true; this.show(index); this.stop(); }
      };
      this.onBlockDeselect = (e) => {
        if (this.slides.includes(e.target)) { this.designMode = false; this.start(); }
      };

      this.prev && this.prev.addEventListener('click', this.onPrev);
      this.next && this.next.addEventListener('click', this.onNext);
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.show(Number(dot.getAttribute('data-reana-dot')));
          this.start();
        });
      });
      this.addEventListener('keydown', this.onKey);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('visibilitychange', this.onVisibility);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.show(0);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    show(index) {
      const total = this.slides.length;
      if (index >= total) index = 0;
      if (index < 0) index = total - 1;
      this.current = index;

      this.slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelectorAll('a, button').forEach((el) => {
          if (active) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '-1');
        });
      });

      this.dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    start() {
      this.stop();
      if (!this.autoplay || this.paused || this.designMode || this.reducedMotion) return;
      if (this.slides.length < 2) return;
      this.timer = setInterval(() => this.show(this.current + 1), this.speed);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }
  }

  customElements.define('reana-slider', ReanaSlider);
}
